export const pluginPrefix = 'PLUGIN:ORDER_ASSIGNMENT:';
export const SET_PRODUCTS_FOR_ASSIGNMENT = `${pluginPrefix}SET_PRODUCTS_FOR_ASSIGNMENT`;
